<template>
  <div>
<!--    <div class="container" v-if="isSpecial !='1'">-->
<!--      <el-row type="flex" align="middle" justify="start">-->
<!--        <el-col :span="6" style="text-align: center">-->
<!--          <el-avatar :size="72" icon="el-icon-user-solid" />-->
<!--        </el-col>-->
<!--        <el-col :span="18" >-->
<!--          <div style="font-size:1.3em;font-weight: bolder;height: 30px;line-height: 30px"><ellipsis :length="25">{{ user.depart }}</ellipsis></div>-->
<!--          <div style="font-size: 1em;height: 30px;line-height: 30px">姓名：{{ user.name }}</div>-->
<!--          &lt;!&ndash;        <div style="font-size: 1em;height: 30px;line-height: 30px">角色：<ellipsis :length="30">{{ user.role }}</ellipsis></div>&ndash;&gt;-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--    </div>-->
    <div class="login-form" style="background:#e8f0fe " v-if="isSpecial =='1'">
      <div class="login-box">
        <!--      <img :src="bkImg" style="height: 100%; flex-shrink: 0;width: calc(100% - 420px);" />-->
        <div class="login-input">
          <!-- <img :src="logoImg" />-->
          <!--        <span class="title">延平区科特派服务云平台注册</span>-->
          <el-form :model="dataForm"  label-width="120px" ref="dataForm"
                   style="width: 100%; margin-top: 4vh;">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="专家名称" prop="Specialist.specialistName">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.specialistName"
                            :clearable="true" placeholder="姓名"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.specialistName}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="证件类型" prop="Specialist.documentType">
                  <el-select class="input-item" v-if="!readOnly" v-model="formData.Specialist.documentType" :clearable="true" filterable
                             placeholder="证件类型" :loading="flowSpecialistAuditForm.documentType.impl.loading"
                             @visible-change="flowSpecialistAuditForm.documentType.impl.onVisibleChange"
                             >
                    <el-option v-for="item in flowSpecialistAuditForm.documentType.impl.dropdownList" :key="item.id"
                               :value="item.id" :label="item.name"
                    />
                  </el-select>
                  <span class="input-item input-label" v-else>{{(formData.Specialist.documentTypeDictMap || {}).name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="身份证号码" prop="Specialist.idCard">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.idCard"
                            :clearable="true" placeholder="身份证号码"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.idCard}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="身份" prop="Specialist.identity">
                  <el-select class="input-item" v-if="!readOnly" v-model="formData.Specialist.identity" :clearable="true" filterable
                             placeholder="身份" :loading="flowSpecialistAuditForm.identity.impl.loading"
                             @visible-change="flowSpecialistAuditForm.identity.impl.onVisibleChange"
                             >
                    <el-option v-for="item in flowSpecialistAuditForm.identity.impl.dropdownList" :key="item.id"
                               :value="item.id" :label="item.name"
                    />
                  </el-select>
                  <span class="input-item input-label" v-else>{{(formData.Specialist.identityDictMap || {}).name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="籍贯" prop="Specialist.nativePlace">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.nativePlace"
                            :clearable="true" placeholder="籍贯"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.nativePlace}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="区级" prop="Specialist.isDistrict">
                  <el-select class="input-item" v-if="!readOnly" v-model="formData.Specialist.isDistrict" :clearable="true" filterable
                             placeholder="区级" :loading="flowSpecialistAuditForm.isDistrict.impl.loading"
                             @visible-change="flowSpecialistAuditForm.isDistrict.impl.onVisibleChange"
                             >
                    <el-option v-for="item in flowSpecialistAuditForm.isDistrict.impl.dropdownList" :key="item.id"
                               :value="item.id" :label="item.name"
                    />
                  </el-select>
                  <span class="input-item input-label" v-else>{{(formData.Specialist.isDistrictDictMap || {}).name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="政治面貌" prop="Specialist.politicalOutlook">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.politicalOutlook"
                            :clearable="true" placeholder="政治面貌"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.politicalOutlook}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="性别" prop="Specialist.gender">
                  <el-select class="input-item" v-model="formData.Specialist.gender" :clearable="true" filterable
                             placeholder="性别" :loading="flowSpecialistAuditForm.gender.impl.loading"
                             @visible-change="flowSpecialistAuditForm.gender.impl.onVisibleChange" v-if="!readOnly"
                             >
                    <el-option v-for="item in flowSpecialistAuditForm.gender.impl.dropdownList" :key="item.id"
                               :value="item.id" :label="item.name"
                    />
                  </el-select>
                  <span class="input-item input-label" v-else>{{(formData.Specialist.genderDictMap || {}).name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8" >
                <el-form-item label="出生日期" prop="Specialist.birthday">
                  <el-date-picker class="input-item" v-if="!readOnly" v-model="formData.Specialist.birthday" :clearable="true"
                                  format="yyyy-MM-dd"
                                  value-format="yyyy-MM-dd"
                                  type="date" align="left"
                                  placeholder="出生日期"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.birthday}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="分类" prop="Specialist.industryId">
                  <el-cascader class="input-item" v-if="!readOnly" v-model="formData.Specialist.industryId" :options="flowSpecialistAuditForm.industryId.impl.dropdownList" filterable
                               :clearable="true" :show-all-levels="false" placeholder="分类"
                               :props="{value: 'id', label: 'name', checkStrictly: true}"
                               @visible-change="flowSpecialistAuditForm.industryId.impl.onVisibleChange"
                               @change="onIndustryIdValueChange"
                  />
                  <span class="input-item input-label" v-else>{{(formData.Specialist.industryIdDictMap || {}).name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="单位性质" prop="Specialist.companyProperties">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyProperties"
                            :clearable="true" placeholder="单位性质"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.companyProperties}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="服务单位" prop="Specialist.serviceCompany">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.serviceCompany"
                            :clearable="true" placeholder="服务单位"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.serviceCompany}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="工作单位属地" prop="Specialist.companyArea">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyArea"
                            :clearable="true" placeholder="工作单位属地"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.companyArea}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="学术称号" prop="Specialist.academicTitle">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.academicTitle"
                            :clearable="true" placeholder="学术称号"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.academicTitle}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电子邮箱" prop="Specialist.email">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.email"
                            :clearable="true" placeholder="电子邮箱"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.email}}</span>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="学历" prop="Specialist.education">
                  <el-select class="input-item" v-if="!readOnly" v-model="formData.Specialist.education" :clearable="true" filterable
                             placeholder="学历" :loading="flowSpecialistAuditForm.education.impl.loading"
                             @visible-change="flowSpecialistAuditForm.education.impl.onVisibleChange"
                             @change="onEducationValueChange">
                    <el-option v-for="item in flowSpecialistAuditForm.education.impl.dropdownList" :key="item.id"
                               :value="item.id" :label="item.name"
                    />
                  </el-select>
                  <span class="input-item input-label" v-else>{{(formData.Specialist.educationDictMap || {}).name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8" >
                <el-form-item label="学位" prop="Specialist.degreeLevel">
                  <el-select class="input-item" v-if="!readOnly" v-model="formData.Specialist.degreeLevel" :clearable="true" filterable
                             placeholder="学位" :loading="flowSpecialistAuditForm.degreeLevel.impl.loading"
                             @visible-change="flowSpecialistAuditForm.degreeLevel.impl.onVisibleChange"
                             >
                    <el-option v-for="item in flowSpecialistAuditForm.degreeLevel.impl.dropdownList" :key="item.id"
                               :value="item.id" :label="item.name"
                    />
                  </el-select>
                  <span class="input-item input-label" v-else>{{(formData.Specialist.degreeLevelDictMap || {}).name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8" >
                <el-form-item label="职称" prop="Specialist.specialistTitleId">
                  <el-select class="input-item" v-if="!readOnly" v-model="formData.Specialist.specialistTitleId" :clearable="true" filterable
                             placeholder="职称" :loading="flowSpecialistAuditForm.specialistTitleId.impl.loading"
                             @visible-change="flowSpecialistAuditForm.specialistTitleId.impl.onVisibleChange"
                             >
                    <el-option v-for="item in flowSpecialistAuditForm.specialistTitleId.impl.dropdownList" :key="item.id"
                               :value="item.id" :label="item.name"
                    />
                  </el-select>
                  <span class="input-item input-label" v-else>{{(formData.Specialist.specialistTitleIdDictMap || {}).name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系电话" prop="Specialist.mobilePhone">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.mobilePhone"
                            :clearable="true" placeholder="联系电话"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.mobilePhone}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8" >
                <el-form-item label="工作单位" prop="Specialist.companyName">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyName"
                            :clearable="true" placeholder="工作单位"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.companyName}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="职位" prop="Specialist.companyPost">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyPost"
                            :clearable="true" placeholder="职位"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.companyPost}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="单位联系人" prop="Specialist.companyContacts">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyContacts"
                            :clearable="true" placeholder="单位联系人"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.companyContacts}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="单位联系电话" prop="Specialist.companyTel">
                  <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyTel"
                            :clearable="true" placeholder="单位联系电话"
                  />
                  <span class="input-item input-label" v-else>{{formData.Specialist.companyTel}}</span>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { DropdownWidget } from '@/utils/widget.js';
import { DictionaryController, SpecialistController } from '@/api';

export default {
  name: 'personInfo',

  data () {
    return {
      readOnly: true,
      user: {
        depart: '',
        name: '',
        role: ''
      },
      isSpecial: '',
      flowSpecialistAuditForm: {
        gender: {
          impl: new DropdownWidget(this.loadGenderDropdownList)
        },
        documentType: {
          impl: new DropdownWidget(this.loadDocumentTypeDropdownList)
        },
        identity: {
          impl: new DropdownWidget(this.loadIdentityDropdownList)
        },
        isDistrict: {
          impl: new DropdownWidget(this.loadIsDistrictDropdownList)
        },
        degreeLevel: {
          impl: new DropdownWidget(this.loadDegreeLevelDropdownList)
        },
        education: {
          impl: new DropdownWidget(this.loadEducationDropdownList)
        },
        specialistTitleId: {
          impl: new DropdownWidget(this.loadSpecialistTitleIdDropdownList)
        },
        industryId: {
          impl: new DropdownWidget(this.loadIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        isInit: false
      },

      formData: {
        Specialist: {

        }
      }
    }
  },

  created () {
    console.info(this.$store.state.userInfo)
    // console.log(JSON.stringify(this.$store.state.userInfo))
    this.user.name = this.$store.state.userInfo.showName
    this.user.depart = this.$store.state.userInfo.deptName
    this.isSpecial = this.$store.state.userInfo.isSpecial
    /*
      this.user.role = this.$store.state.userInfo.postNameList.join('、') */
  },
  methods: {
    /**
       * 性别下拉数据获取函数
       */
    loadGenderDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictGenderDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadDocumentTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDocumentTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadIdentityDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIdentityDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadIsDistrictDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDistrictDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadDegreeLevelDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDegreeLevelDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 学历下拉数据获取函数
       */
    loadEducationDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictEducationDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 学历选中值改变
       */
    onEducationValueChange (value) {
    },
    /**
       * 职称下拉数据获取函数
       */
    loadSpecialistTitleIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysTitlesDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 分类下拉数据获取函数
       */
    loadIndustryIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 分类选中值改变
       */
    onIndustryIdValueChange (value) {
      this.dataForm.industryId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    loadInfo (userId) {
      let params = {
        specialistDtoFilter: {
        },
        userId: 'userId',
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }

      SpecialistController.list(this, params, null, {showMask: false}).then(data => {
        if (data.data.dataList.length > 0) {
          this.formData.Specialist = data.data.dataList[0]
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    padding:20px 0;
    border-bottom: 1px solid #e4e4e4;
    height: 125px;
    /deep/.el-avatar{
      font-size:50px;
      border-radius:40% !important;
      background-color:rgb(117,150,255) !important;
    }
  }

  .login-form {
    width: 100vw;
    height: 100vh;
    background: #292D36;
    display: flex;
    justify-content: center;
    align-items: center;
    .login-box {
      display: flex;
      align-items: center;
      height: 80vh;
      width: 90vw;
      padding: 5vh;
      border-radius: 3px;
      background: white;
      .login-input {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        img {
          width: 356px;
          height: 42px;
          margin-top: 6vh;
        }
        .title {
          color: #232323;
          font-size: 20px;
          /*margin-top: 1vh;*/
        }
      }
    }
  }

  /*.login-form .el-input__inner {*/
  /*  height: 45px!important;*/
  /*}*/

  .login-form .el-button {
    height: 45px!important;
    font-size: 20px;
  }
  .putbox {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
  }

  .codebtn {
    width: 120px;
    height: 40px;
    font-size: 11px;
    color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 10px;
    justify-content: center;
    background-color: #009dff;
    margin-left: 10px;
  }
  .codebtn2{
    width: 120px;
    height: 40px;
    font-size: 11px;
    color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 10px;
    justify-content: center;
    background-color: #009dff;
    margin-left: 10px;
    pointer-events: none; // 禁止鼠标点击事件
  }
</style>
